import { RetailerFooter } from "@faire/deprecated-retailer-visitor-shared/components/Footer/RetailerFooter";
import { SideBar as SideBarBase } from "@faire/deprecated-retailer-visitor-shared/views/settings/SideBar";
import { LoadingSpinner } from "@faire/web/slate-deprecated/LoadingSpinner";
import { responsiveMediaQueries } from "@faire/web/slate/Theme/responsiveMediaQueries";
import { Typography } from "@faire/web/slate/Typography";
import { useViewport } from "@faire/web/ui/hooks/useViewport";
import { StrictLocalMsg } from "@faire/web/ui/lib/localization";
import React from "react";
import styled from "styled-components";

export const CONTENT_PADDING_LEFT = "50px";

interface IProps {
  children?: React.ReactNode | undefined;
  page: string;
  isLoading?: boolean;
  className?: string;
  fullWidth?: boolean;
}

export const Layout = ({
  ref,
  ...props
}: IProps & {
  ref?: React.Ref<HTMLElement>;
}) => {
  const { isTabletAndBelow } = useViewport();

  const { children, page, isLoading, className, fullWidth } = props;

  return (
    <Wrapper className={className} ref={ref}>
      {isTabletAndBelow ? (
        <Heading variant="subheadingSansMedium">
          <StrictLocalMsg
            id="j4pe1E"
            defaultMessage="Settings"
            description={{
              text: "Title informing the retailer that this is the account settings page",
            }}
          />
        </Heading>
      ) : null}
      <ContentWrapper>
        <SideBar className="retailer-settings-sidebar" selected={page} />
        <Content className="main-content" $fullWidth={fullWidth}>
          {isLoading ? (
            <Loader data-test-id="layout-loading-spinner" />
          ) : (
            children
          )}
        </Content>
      </ContentWrapper>
      <RetailerFooter noTopBorder />
    </Wrapper>
  );
};

const Wrapper = styled.section`
  display: flex;
  flex-direction: column;
  flex: 1 1 0%;
`;

const ContentWrapper = styled.section`
  display: flex;
  border-bottom: 1px solid #eaeaea;
  flex-direction: row;
  flex-grow: 1;
  ${responsiveMediaQueries.tabletAndBelow} {
    flex-direction: column;
  }
`;

const SideBar = styled(SideBarBase)`
  width: 220px;
  border-right: 2px solid #eaeaea;
  display: flex;
  flex-direction: column;
  padding: 42px 36px 42px 36px;

  ${responsiveMediaQueries.tabletAndBelow} {
    width: 100%;
    padding: 15px;
    border-right: none;
  }
`;

const Content = styled.section<{ $fullWidth?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  flex: 1;
  max-width: ${({ $fullWidth }) => ($fullWidth ? undefined : "800px")};
  align-content: flex-start;
  padding: 20px ${CONTENT_PADDING_LEFT};
  position: relative;
  ${responsiveMediaQueries.tabletAndBelow} {
    padding: 0 15px;
    max-width: 100%;
    width: 100%;
  }
`;

const Loader = styled(LoadingSpinner)`
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  margin: auto;
  width: 50px;
  height: 50px;
`;

const Heading = styled(Typography)`
  margin: 40px 16px 0 16px;
`;
